// Next.js Link component replacement
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import { forwardRef } from "react";

type NextLinkProps = Omit<RouterLinkProps, "to"> & {
  href?: string;
  to?: RouterLinkProps["to"];
};

export const Link = forwardRef<HTMLAnchorElement, NextLinkProps>(
  ({ to, href, ...props }, ref) => {
    // Use href if to is not provided (Next.js compatibility)
    const destination = to || href || "/";

    // Handle external links
    if (
      typeof destination === "string" &&
      (destination.startsWith("http") || destination.startsWith("//"))
    ) {
      return <a href={destination} ref={ref} {...props} />;
    }

    return <RouterLink to={destination} ref={ref} {...props} />;
  }
);

Link.displayName = "Link";

export default Link;
